import type { CommandContext, CommandFactory, SlashCommand } from './types'
import { helpCommand, createHelpMessage } from './help'
import { searchCommand } from './search'
import { webSearchCommand } from './web-search'
import { artifactCommand } from './artifact'
import { themeCommand } from './theme'
import { identityCommand } from './identity'
import {
  generateWalletCommand,
  restoreWalletCommand,
  exportWalletCommand,
  deleteWalletCommand,
  viewWalletCommand,
} from './wallet'
import {
  myListingsCommand,
  marketplaceSearchCommand,
} from './marketplace'

// Registry of all command factories
const commandFactories: CommandFactory[] = [
  helpCommand,
  searchCommand,
  webSearchCommand,
  artifactCommand,
  themeCommand,
  identityCommand,
  generateWalletCommand,
  restoreWalletCommand,
  viewWalletCommand,
  exportWalletCommand,
  deleteWalletCommand,
  myListingsCommand,
  marketplaceSearchCommand,
]

/**
 * Creates all available slash commands with the provided context
 */
export const createAvailableCommands = (
  context: CommandContext
): SlashCommand[] => {
  const commands = commandFactories.map((factory) => factory(context))

  // Special handling for help command - inject the actual help message generator
  const helpCmd = commands.find((cmd) => cmd.id === 'help')
  if (helpCmd) {
    helpCmd.handler = async () => {
      const helpContent = createHelpMessage(commands)
      context.onDisplayMessage?.({
        role: 'command',
        content: helpContent,
        timestamp: new Date(),
      })
    }
  }

  return commands
}

// Re-export types for convenience
export type { SlashCommand, CommandContext, CommandFactory } from './types'
